// extracted by mini-css-extract-plugin
export var highlightFade = "_32-4";
export var highlighted = "_32-3";
export var table = "_32-1";
export var tableContainer = "_32-0";
export var totalsRow = "_32-2";